import { useQuery } from '@tanstack/react-query';
import { getMyAccess, type MyAccess } from '@/data/client';
import { useViewAsClient } from './viewAsClient';

/* The signed-in user's effective client access (role + capabilities), from
   /api/me. Drives nav + route gating. The Worker independently enforces access
   server-side — this is UX only. */
export function useClientAccess(): { access?: MyAccess; isLoading: boolean } {
  // While an admin is viewing as a client, ask the Worker for a client's
  // capabilities (compare flag, role) so the demo matches what a client sees.
  const [asClient] = useViewAsClient();
  const { data, isLoading } = useQuery({ queryKey: ['myAccess', asClient], queryFn: () => getMyAccess(asClient), staleTime: 5 * 60_000 });
  return { access: data, isLoading };
}
